import template from './productsListAssetFinance.template.html';

export default {
  template,
  bindings: {
    lenders: '<',
    documents: '<',
    products: '<',
    chosenProducts: '<',
    isCommercial: '<',
    isQuickTool: '<',
    isLoadingFinished: '<',
    onSelected: '&',
    onLoadMore: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew, helperService, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentCurrency = null;
      ctrl.currentDateFormat = null;
      ctrl.availableProductFeeTypes = [];
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = ({ isInitialized }) => {
        if (isInitialized) {
          ctrl.currentCurrency = $rootScope.CurrentCurrency();
          ctrl.currentDateFormat = $rootScope.CurrentDateFormat();
          ctrl.lenders = ctrl.lenders || [];
          ctrl.documents = ctrl.documents || [];
          ctrl.products = ctrl.products || [];
          ctrl.chosenProducts = ctrl.chosenProducts || [];
          ctrl.isCommercial = ctrl.isCommercial || false;
          ctrl.isQuickTool = ctrl.isQuickTool || false;
          ctrl.isLoadingFinished = ctrl.isLoadingFinished || false;
          ctrl.availableProductFeeTypes = helperService.getAvailableProductFeeTypes();
          ctrl.isLoadMore = false;
          ctrl.onReady({ list: ctrl.list });
          ctrl.list.setOrderBy('getAssetFinanceTotalCosts()');
          ctrl.list.setData(ctrl.products);
        } else {
          ctrl.list.setDataAppend(ctrl.products);
          ctrl.isLoadMore = false;
        }
        ctrl.getLowestCost();
        ctrl.canScroll = ctrl.isLoadingFinished;
      };

      ctrl.getLowestCost = () => {
        ctrl.lowestCostProduct = _.minBy(
          ctrl.list.getData() || [],
          (item) => item?.assetFinanceEstimate[0]?.product?.totalCosts
        );
      };

      ctrl.select = (data) => {
        ctrl.list.setSelected(data);
        if (
          (ctrl.isQuickTool && ctrl.chosenProducts.length <= 1) ||
          (!ctrl.isQuickTool && ctrl.chosenProducts.length <= 4)
        ) {
          ctrl.onSelected({ data });
        } else if (!ctrl.isQuickTool && ctrl.chosenProducts.length > 4) {
          uiService.toast({
            text: {
              p1: 'Four products',
              p2: 'are maximum',
              p3: 'for compare'
            },
            warn: true
          });
        }
      };

      ctrl.productsLoadMore = () => {
        if (ctrl.canScroll) {
          ctrl.onLoadMore();
        }
        ctrl.isLoadMore = ctrl.isLoadingFinished;
        ctrl.canScroll = false;
      };

      ctrl.getLender = (idLender) => {
        const lender = _.find(ctrl.lenders || [], (l) => l?.id === idLender);
        return lender || 'N/A';
      };

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d?.lender[0]?.id === idLender && _.indexOf(d?.type, 'LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.getFeeType = (fee) => {
        const feeType = _.find(ctrl.availableProductFeeTypes, (t) => t.id === fee.type);
        return feeType ? feeType.value : 'N/A';
      };

      ctrl.getLastDateModified = (dateString) => {
        if (dateString && _.isString(dateString)) {
          const dateObj = new Date(dateString);
          return moment(dateObj).format(ctrl.currentDateFormat);
        }
        return '-';
      };

      ctrl.$onInit = () => {
        ctrl.initialize({ isInitialized: true });
      };

      ctrl.$onChanges = (changes) => {
        if (
          changes?.products &&
          !_.isEmpty(changes?.products?.previousValue) &&
          changes?.products?.currentValue
        ) {
          ctrl.initialize({ isInitialized: false });
        }
      };
    }
  }
};
